import { render, staticRenderFns } from "./previewModel.vue?vue&type=template&id=04e78e5b&scoped=true"
import script from "./previewModel.vue?vue&type=script&lang=js"
export * from "./previewModel.vue?vue&type=script&lang=js"
import style0 from "./previewModel.vue?vue&type=style&index=0&id=04e78e5b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e78e5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e78e5b')) {
      api.createRecord('04e78e5b', component.options)
    } else {
      api.reload('04e78e5b', component.options)
    }
    module.hot.accept("./previewModel.vue?vue&type=template&id=04e78e5b&scoped=true", function () {
      api.rerender('04e78e5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/previewFrom/previewModel.vue"
export default component.exports